import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './styles.module.css';

const practices = [
  {
    title: 'Corporate & Commercial Transactions',
    description:
      'Comprehensive legal support for everyday business operations, commercial relationships, and strategic business initiatives.',
    link: '/practices/corporate-transactions',
  },
  {
    title: 'Mergers & Acquisitions',
    description:
      'Guiding buyers and sellers through business acquisitions, sales, restructurings, and due diligence.',
    link: '/practices/mergers-acquisitions',
  },
  {
    title: 'Business Formation & Governance',
    description:
      'Entity formation, corporate structures, ownership agreements, and ongoing governance support.',
    link: '/practices/business-formation',
  },
  {
    title: 'Contracts & Negotiations',
    description:
      'Drafting, reviewing, and negotiating the agreements that define and protect your business.',
    link: '/practices/contracts',
  },
  {
    title: 'Cross-Border & International Business',
    description:
      'Legal guidance for companies operating across borders, entering new markets, or expanding globally.',
    link: '/practices/cross-border',
  },
  {
    title: 'Private Investments & Financing',
    description:
      'Structuring financing deals, private investments, lending arrangements, and capital transactions.',
    link: '/practices/investments',
  },
];

function PracticeAreas() {
  const navigate = useNavigate();

  const handleCardClick = (link: string) => {
    navigate(link);
  };

  return (
    <div className={styles.practiceSection}>
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>Our Areas of Practice</h2>
        <p className={styles.sectionSubtitle}>
          Comprehensive legal support across all aspects of commercial
          transactions and business operations.
        </p>
      </div>

      <div className={styles.horizontalScrollContainer}>
        <div className={styles.scrollableGrid}>
          {practices.map((practice, index) => (
            <div
              key={index}
              className={styles.practiceCard}
              onClick={() => handleCardClick(practice.link)}
              role="button"
              tabIndex={0}
              // onKeyPress is deprecated — use onKeyDown instead
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault(); // prevent page scroll on Space
                  handleCardClick(practice.link);
                }
              }}
            >
              <h3 className={styles.practiceTitle}>{practice.title}</h3>
              <p className={styles.practiceDescription}>
                {practice.description}
              </p>
              <div className={styles.learnMore}>Learn More →</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PracticeAreas;
